import React, { useContext, useEffect, useState } from "react";
import "../../../../assets/css/seller/SellerSignUp/sellerSignUp.css";
import logo from "../../../../assets/images/logo.png";
import axios from "axios";
import AppContext from "../../../../context/AppContext";
import { useNavigate } from "react-router-dom";

// ── Store Icon ────────────────────────────────────────────────────────────────
const StoreIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.822 7.431A1 1 0 0 0 21 7H7.333L6.179 4.23A1.994 1.994 0 0 0 4.333 3H2v2h2.333l4.744 11.385A1 1 0 0 0 10 17h8c.417 0 .79-.259.937-.648l3-8a1 1 0 0 0-.115-.921zM17.307 15h-6.64l-2.5-6h11.39l-2.25 6z" />
    <circle cx="10.5" cy="19.5" r="1.5" />
    <circle cx="17.5" cy="19.5" r="1.5" />
  </svg>
);

// ── Eye Icons ─────────────────────────────────────────────────────────────────
const EyeIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

// ── Chevron Down Icon ─────────────────────────────────────────────────────────
const ChevronDown = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

// ── Business categories ───────────────────────────────────────────────────────
const CATEGORIES = [
  "Electronics",
  "Fashion & Clothing",
  "Home & Living",
  "Beauty & Personal Care",
  "Sports & Outdoors",
  "Books & Stationery",
  "Food & Grocery",
  "Toys & Games",
  "Automotive",
  "Other",
];

// ── Main Component ────────────────────────────────────────────────────────────
const Sellersignup = ({ onNavigateLogin, onNavigateCustomer }) => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [businessCategory, setBusinessCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [businessAddress, setBusinessAddress] = useState("");
  const [isShopOwner, setIsShopOwner] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [shopName, setShopName] = useState("");
  const [cnicNumber, setCnicNumber] = useState("");
  const { baseUrl, regTpChecker, setLoggedInSeller } = useContext(AppContext);
  const navigate = useNavigate();

  // ── Axios instance with JWT interceptor ──
  // baseUrl AppContext se aata hai (Laravel API ka root URL)
  const api = axios.create({
    baseURL: baseUrl,
  });

  api.interceptors.request.use((config) => {
    const token = localStorage.getItem("jwt_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
  const getAllCategories = () => {
    axios
      .post(`${baseUrl}/shop/tpcategory/viewAllUploadedCategories`)
      .then((res) => {
        console.log("Categories:", res.data.categoryRecords);
        setCategories(res.data.categoryRecords || []);
      })
      .catch((err) => {
        console.error("Category fetch error:", err);
        setCategories([]);
      });
  };

  const registerSeller = () => {
    console.log("*********");
    console.log("*********");
    console.log(fullName, isShopOwner);
    console.log("*********");
    console.log("*********");

    setErrorMessage("");
    setSuccessMessage("");

    const formData = new FormData();
    formData.append("fullName", fullName);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("password", password);
    formData.append("businessName", businessName);
    formData.append("businessCategory", businessCategory);
    formData.append("businessAddress", businessAddress);
    formData.append("isShopOwner", isShopOwner);
    if (isShopOwner) {
      formData.append("shopname", shopName);
      formData.append("cnicNumber", cnicNumber);
    }

    axios
      .post(`${baseUrl}/seller/auth/registerSeller`, formData, {
        // headers: { "Content-type": "multipart/formData" },
      })
      .then((response) => {
        console.log(response.data);

        if (response.data.success) {
          localStorage.setItem("sellerToken", response.data.token);

          localStorage.setItem(
            "loggedInSeller",
            JSON.stringify(response.data.shop),
          );

          setLoggedInSeller(response.data.shop);

          setSuccessMessage("Signup successful! Redirecting...");

          navigate("/seller-dashboard");
        } else {
          // ✅ FIX — ab backend ka asal message dikhega (agar bheja ho)
          setErrorMessage(
            response.data.message ||
              response.data.error ||
              "Signup failed. Please try again.",
          );
        }
      })
      .catch((error) => {
        console.log(error);
        console.log("Backend Error Response:", error.response?.data);

        // ==========================================
        // ✅ FIX — pehle hardcoded "Email already exists!"
        // hamesha show hota tha, chahe error kuch bhi ho.
        // Ab asal backend error/message dikhega taake
        // real wajah pata chal sake.
        // ==========================================
        const backendMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Signup failed. Please try again.";

        setErrorMessage(backendMessage);
      });
  };
  useEffect(() => {
    getAllCategories();
  }, [baseUrl]);

  return (
    <div className="sr-page">
      {/* ── Card ── */}
      <div className="sr-card">
        {/* LOGO */}
        <div className="sidebar-logo">
          <img src={logo} alt="Logo" className="logo-icon" />
        </div>

        {/* ── Heading ── */}
        <div className="sr-heading">
          <h1 className="sr-heading__title">Seller SignUp</h1>
          <p className="sr-heading__sub">
            Register to start selling on Time4Pulse
          </p>
        </div>
        {/* Error Message */}
        {errorMessage && (
          <div className="buyer-error-message">{errorMessage}</div>
        )}
        {/* Success Message */}
        {successMessage && (
          <div className="buyer-success-message">{successMessage}</div>
        )}

        <form noValidate>
          {/* Full Name */}
          <div className="sr-field">
            <label className="sr-label" htmlFor="sr-fullname">
              Full Name
            </label>
            <input
              id="sr-fullname"
              type="text"
              className="sr-input sr-input--plain"
              placeholder="Enter your full name"
              value={fullName}
              onChange={(e) => {
                setFullName(e.target.value);
                setErrorMessage(regTpChecker("fullName", e.target.value));
              }}
              autoComplete="name"
              required
            />
          </div>

          {/* Email */}
          <div className="sr-field">
            <label className="sr-label" htmlFor="sr-email">
              Email Address
            </label>
            <input
              id="sr-email"
              type="email"
              className="sr-input sr-input--plain"
              placeholder="seller@email.com"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setErrorMessage(regTpChecker("email", e.target.value));
              }}
              autoComplete="email"
              required
            />
          </div>

          {/* Phone */}
          <div className="sr-field">
            <label className="sr-label" htmlFor="sr-phone">
              Phone Number
            </label>
            <input
              id="sr-phone"
              type="tel"
              className="sr-input sr-input--plain"
              placeholder="03XX XXXXXXX"
              value={phone}
              onChange={(e) => {
                setPhone(e.target.value);
                setErrorMessage(regTpChecker("phoneNumber", e.target.value));
              }}
              autoComplete="tel"
              required
            />
          </div>

          {/* Password */}
          <div className="sr-field">
            <label className="sr-label" htmlFor="sr-password">
              Password
            </label>
            <div className="sr-input-wrap">
              <input
                id="sr-password"
                type={showPass ? "text" : "password"}
                className="sr-input"
                placeholder="Create a password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setErrorMessage(regTpChecker("password", e.target.value));
                }}
                autoComplete="new-password"
                required
              />
              <button
                type="button"
                className="sr-eye-btn"
                onClick={() => setShowPass((p) => !p)}
                aria-label={showPass ? "Hide password" : "Show password"}
              >
                {showPass ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>
          </div>

          {/* Confirm Password */}
          <div className="sr-field">
            <label className="sr-label" htmlFor="sr-confirm">
              Confirm Password
            </label>
            <div className="sr-input-wrap">
              <input
                id="sr-confirm"
                type={showConfirm ? "text" : "password"}
                className="sr-input"
                placeholder="Confirm your password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                autoComplete="new-password"
                required
              />
              <button
                type="button"
                className="sr-eye-btn"
                onClick={() => setShowConfirm((p) => !p)}
                aria-label={showConfirm ? "Hide password" : "Show password"}
              >
                {showConfirm ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>
          </div>

          {/* ── Business Information ── */}
          <div className="sr-biz-section">
            <div className="sr-biz-label">Business Information</div>

            {/* Business Name */}
            <div className="sr-field">
              <label className="sr-label" htmlFor="sr-bizname">
                Business Name
              </label>
              <input
                id="sr-bizname"
                type="text"
                className="sr-input sr-input--plain"
                placeholder="Your business or brand name"
                value={businessName}
                onChange={(e) => setBusinessName(e.target.value)}
              />
            </div>

            {/* Business Category */}
            <div className="sr-field">
              <label className="sr-label" htmlFor="sr-bizcat">
                Business Category
              </label>
              <div className="sr-select-wrap">
                <select
                  id="sr-bizcat"
                  className="sr-select"
                  value={businessCategory}
                  onChange={(e) => setBusinessCategory(e.target.value)}
                >
                  <option value="">Select your business category</option>

                  {categories.map((category) => (
                    <option key={category.id} value={category.id}>
                      {category.categoryName}
                    </option>
                  ))}
                </select>
                <span className="sr-chevron">
                  <ChevronDown />
                </span>
              </div>
            </div>

            {/* Business Address */}
            <div className="sr-field">
              <label className="sr-label" htmlFor="sr-bizaddr">
                Business Address
              </label>
              <input
                id="sr-bizaddr"
                type="text"
                className="sr-input sr-input--plain"
                placeholder="Full business address"
                value={businessAddress}
                onChange={(e) => setBusinessAddress(e.target.value)}
              />
            </div>
          </div>

          {/* KYC Checkbox */}
          <label className="sr-checkbox-row">
            <input
              type="checkbox"
              checked={isShopOwner}
              onChange={(e) => setIsShopOwner(e.target.checked)}
            />
            <span>I am a shop owner (requires KYC verification)</span>
          </label>

          {/* Shop Owner Extra Fields */}
          {isShopOwner && (
            <div className="sr-shop-extra">
              <p className="sr-shop-note">
                As a shop owner, you'll need to complete KYC verification after
                registration.
              </p>

              <div className="sr-field">
                <label className="sr-label" htmlFor="sr-shopname">
                  Shop Name
                </label>
                <input
                  id="sr-shopname"
                  type="text"
                  className="sr-input sr-input--plain"
                  placeholder="Your shop name"
                  value={shopName}
                  onChange={(e) => setShopName(e.target.value)}
                />
              </div>
              <div className="sr-field">
                <label className="sr-label" htmlFor="sr-cnic">
                  CNIC Number
                </label>
                <input
                  id="sr-cnic"
                  type="text"
                  className="sr-input sr-input--plain"
                  placeholder="XXXXX-XXXXXXX-X"
                  value={cnicNumber}
                  onChange={(e) => setCnicNumber(e.target.value)}
                />
              </div>
            </div>
          )}

          {/* Submit */}
          <button
            type="button"
            className="sr-submit-btn"
            onClick={registerSeller}
          >
            Register as Seller
          </button>
        </form>

        {/* Footer */}
        <div className="sr-footer">
          <p className="sr-footer__login">
            Already have an account?{" "}
            <a
              href="#login"
              onClick={(e) => {
                e.preventDefault();
                navigate("/seller-login");
              }}
            >
              Login
            </a>
          </p>
          <button className="sr-footer__customer" onClick={onNavigateCustomer}>
            ← Register as Customer
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sellersignup;